import TransfersList from './TransfersList';
import TransfersShow from './TransfersShow';

export default {
  list: TransfersList,
  show: TransfersShow,
};
